<div class="modal-content" [class.shadow-none]="false">
  <div class="modal-header align-items-start">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ title }}</h2>
    </div>
    <button type="button" class="btn-close" [attr.aria-label]="'common.close' | translate" (click)="cancel()"></button>
  </div>
  <div class="modal-body">
    <p class="mb-0" style="white-space: pre-line;">{{ description }}</p>
  </div>
  <div class="modal-footer">
    <div class="button box">
      @if (isError) {
        <app-button
          [label]="'common.ok' | translate"
          [variant]="'primary'"
          (clicked)="cancel()"
        />
      } @else {
        <app-button
          [label]="cancelLabel"
          [variant]="'outline'"
          class="me-3"
          (clicked)="cancel()"
        />
        <app-button
          [label]="confirmLabel"
          [variant]="'danger'"
          (clicked)="confirm()"
        />
      }
    </div>
  </div>
</div>
